import { FormikState } from 'formik';
import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';
import { Filter } from 'types';
import { NewCentralFormType } from '../types';
import { SearchEntityEnum } from '../v3/search-v3-types';

type ResetFormTypeFnRef = {
  current: (
    nextState?: Partial<FormikState<NewCentralFormType>> | undefined
  ) => void;
};

export type SearchContextType = {
  currentFormValues?: NewCentralFormType;
  setCurrentFormValues?: Dispatch<
    SetStateAction<NewCentralFormType | undefined>
  >;
  lastUsedFilter?: Filter[];
  setLastUsedFilter?: Dispatch<SetStateAction<Filter[] | undefined>>;
  resetForm?: ResetFormTypeFnRef;
  setResetForm?: Dispatch<SetStateAction<ResetFormTypeFnRef | undefined>>;
  validSearchSpace: SearchEntityEnum[];
  setValidSearchSpace?: Dispatch<SetStateAction<SearchEntityEnum[]>>;
};

const SearchContext = createContext<SearchContextType>({
  validSearchSpace: [],
});

export const SearchContextProvider: React.FC = ({ children }) => {
  const [lastUsedFilter, setLastUsedFilter] = useState<Filter[]>();
  const [currentFormValues, setCurrentFormValues] = useState<
    NewCentralFormType
  >();

  const [resetForm, setResetForm] = useState<ResetFormTypeFnRef>();
  const [validSearchSpace, setValidSearchSpace] = useState<SearchEntityEnum[]>(
    []
  );

  const ctx = useMemo(
    () => ({
      lastUsedFilter,
      setLastUsedFilter,
      currentFormValues,
      setCurrentFormValues,
      resetForm,
      setResetForm,
      validSearchSpace,
      setValidSearchSpace,
    }),
    [
      lastUsedFilter,
      setLastUsedFilter,
      currentFormValues,
      setCurrentFormValues,
      resetForm,
      setResetForm,
      validSearchSpace,
      setValidSearchSpace,
    ]
  );
  return (
    <SearchContext.Provider value={ctx}>{children}</SearchContext.Provider>
  );
};
export const useSearchContext = () => useContext(SearchContext);
